export const PUBLICSITE_COOKIE_KEY_LOCALE = 'x-cic-publicsite-locale';
export const interestHref = `/talk-to-expert`;
